import { render, staticRenderFns } from "./upload-multiple-demo.vue?vue&type=template&id=d13b371e"
import script from "./upload-multiple-demo.vue?vue&type=script&lang=js"
export * from "./upload-multiple-demo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports